//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const clienteService = {
  doGet,
  doSave,
  findByFiltro,
  findAll,
  findByCodigoCliente,
  findByDocumento,
};

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.CLIENTE}${id}`);
}

function doSave(cliente) {
  return defaultService.doSave(urlsConstants.API_CLIENTE, cliente);
}

function findAll() {
  return defaultService.doGet(`${urlsConstants.API_CLIENTE}findAll`);
}

function findByFiltro(options: Options, filter: any): Promise<any> {
  const params = [];

  if (_.get(filter, 'nomeFantasia')) {
    params.push(`nomeFantasia=${encodeURIComponent(filter.nomeFantasia)}`);
  }

  if (_.get(filter, 'razaoSocial')) {
    params.push(`razaoSocial=${encodeURIComponent(filter.razaoSocial)}`);
  }
  if (_.get(filter, 'cnpjCpf')) {
    params.push(`cnpjCpf=${encodeURIComponent(filter.cnpjCpf)}`);
  }
  params.push(`page=${options.page - 1}`);

  const queryString = params.length > 0 ? `?${params.join('&')}` : '';

  return defaultService.doGet(
    `${urlsConstants.API_CLIENTE}filtro${queryString}`,
    options
  );
}

function findByCodigoCliente(codigoCliente) {
  return defaultService.doGet(
    `${urlsConstants.API_FIND_BY_CODIGO_CLIENTE}?codigoCliente=${codigoCliente}`
  );
}

function findByDocumento(documento) {
  return defaultService.doGet(
    `${urlsConstants.CLIENTE_BY_DOCUMENTO}${encodeURIComponent(documento)}`
  );
}
